module.exports = __webpack_public_path__ + "static/img/icon-toupiao@2x.4e92510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/icon-toupiao@2x.png
// module id = 899
// module chunks = 0